import { useCallback, useEffect, useMemo, useState } from 'react';

import StorageHelper from '../helpers/StorageHelper';

/**
 * @param {string} storeKeyName
 * @param {*|function} fetcher
 * @returns {{
 *   data: *,
 *   error: *,
 *   refresh: (function(): Promise|PromiseLike),
 *   refreshing: boolean,
 * }}
 */
export default function useOffline(storeKeyName, fetcher) {
  const [error, setError] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [data, setData] = useState(StorageHelper.getItem(storeKeyName));

  if (!storeKeyName || typeof storeKeyName !== 'string') {
    throw new Error('Prop "storeKeyName" must be a non-empty string.');
  }

  const doRefresh = useMemo(() => {
    return storeKeyName && typeof storeKeyName === 'string' && typeof fetcher === 'function';
  }, [storeKeyName, fetcher]);

  const refresh = useCallback(async () => {
    if (!doRefresh) {
      return null;
    }

    let response;
    setRefreshing(true);

    try {
      response = await fetcher();
      const data = response?.data;

      setError(null);
      setData(response?.data);

      // Salvar offline
      StorageHelper.setItem(storeKeyName, data);
    } catch (err) {
      setError(err);
    }

    setRefreshing(false);
    return response;
  }, [storeKeyName, fetcher, doRefresh]);

  useEffect(() => {
    // Buscar online
    doRefresh && refresh();
  }, [refresh, doRefresh]);

  return { data, error, refresh, refreshing };
}
